import styled from "styled-components";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

const LayoutWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Main = styled.main`
  flex: 1;
  padding-top: 64px;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}px) {
    padding-top: 80px;
  }
`;

export function Layout({ children }) {
  return (
    <LayoutWrapper>
      <Navbar />
      <Main>{children}</Main>
      <Footer />
    </LayoutWrapper>
  );
}
